export default __webpack_public_path__ + "static/network-830d439bc8ca7ba7a1827cb24287de9b.svg";